import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initErrorTelemetry } from "./lib/errorTelemetry";

// Initialize global error telemetry before React mounts
initErrorTelemetry();

createRoot(document.getElementById("root")!).render(<App />);
